'use strict';

(function () {
  angular
    .module('specsguardApp')
    .factory('AreaTemplateAPI', AreaTemplateAPI);

  AreaTemplateAPI.$inject = ['$resource'];

  function AreaTemplateAPI ($resource) {
    return $resource('/api/areatemplate/:id/:controller',
      {
        id: '@_id'
      },
      {
        getAll: {
          method: 'GET',
          isArray: true,
          cache: false
        },
        create: {
          method: 'POST',
          isArray: true,
        },
        update: {
          method: 'PUT',
          isArray: true,
        },
        delete: {
          method: 'DELETE',
          isArray: true,
        },
        saveField: {
          method: 'PUT',
          params: {
            controller: 'saveField'
          }
        },
        clearField: {
          method: 'DELETE',
          params: {
            id: '@id',
            controller: 'clearField'
          }
        },
        copyField: {
          method: 'PUT',
          params: {
            id: '@id',
            controller: 'copyField'
          }
        }
      }
    );
  }

})();
